import { API, AUTH } from "../store"
import defer from "promise-defer"
import { openSnackBar } from "../actions/snack-bar"
import { getUser } from "../actions/users"
import store from "../store"

export const loggingIn = (loggingIn = true) => ({
  type: "LOGGING_IN",
  loggingIn,
})

export const loginError = (error = false) => ({
  type: "LOGIN_ERROR",
  error,
})

export const loginSuccess = (user = {}, token = "") => ({
  type: "LOGIN_SUCCESS",
  user,
  token,
})

export const setUser = (user = {}) => ({
  type: "SET_USER",
  user,
})

export const updateLoggedInUser = (updates = {}) => ({
  type: "UPDATE_LOGGED_IN_USER",
  updates,
})

export const registering = (registering = true) => ({
  type: "REGISTERING",
  registering,
})

export const registerError = (error = false) => ({
  type: "REGISTER_ERROR",
  error,
})

export const registerSuccess = (user = {}, token = "") => ({
  type: "REGISTER_SUCCESS",
  user,
  token,
})

export const logout = () => ({
  type: "LOGOUT",
})

export const setRefreshedUser = () => ({
  type: "USER::SET_REFRESHED_USER",
})

let loginDialogDeferred = null

export const _toggleLoginDialog = (loginDialogOpen = false) => ({
  type: "TOGGLE_LOGIN_DIALOG",
  loginDialogOpen,
})

export const updateUserCompany = updates => ({
  type: "USER::UPDATE_USER_COMPANY",
  updates,
})

export const toggleLoginDialog = (loginDialogOpen = false, canceled) => {
  return dispatch => {
    dispatch(_toggleLoginDialog(loginDialogOpen))
    if (loginDialogOpen === true) {
      loginDialogDeferred = defer()
      return loginDialogDeferred
    } else {
      if (canceled) {
        if (loginDialogDeferred) {
          loginDialogDeferred.reject()
          setTimeout(() => {
            loginDialogDeferred = null
          }, 250)
        }
      }
    }
  }
}

export const login = data => {
  return dispatch => {
    dispatch(loggingIn())
    const deferred = new Promise((resolve, reject) => {
      AUTH.post(`/auth`)
        .set("Content-Type", "application/json")
        .send(data)
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }

          return response
        })
        .then(response => response.body)
        .then(data => {
          if (data.message === "Auth success") {
            API.set("Authorization", data.token)
            AUTH.set("Authorization", data.token)
            dispatch(getUser(data.id, true))
              .then(getUserResponse => {
                dispatch(loggingIn(false))
                dispatch(loginSuccess(getUserResponse, data.token))
                dispatch(
                  openSnackBar({
                    message: "Login Successful",
                  })
                )
                if (loginDialogDeferred) {
                  loginDialogDeferred.resolve()
                  setTimeout(() => {
                    loginDialogDeferred = null
                  }, 250)
                }
                resolve(getUserResponse)
              })
              .catch(reject)
          } else if (data.message === "Auth failed") {
            let err
            if (data.type === "pass") {
              // bad password
              err = "The password was wrong"
            } else {
              // bad pin
              err = "The pin number was wrong"
            }
            dispatch(
              openSnackBar({
                message: err,
              })
            )
            dispatch(loggingIn(false))
            dispatch(loginError(true))
            reject(err)
          } else {
            dispatch(loggingIn(false))
            dispatch(loginError(true))
            reject(data)
          }
        })
        .catch(err => {
          if (loginDialogDeferred) {
            loginDialogDeferred.reject()
            setTimeout(() => {
              loginDialogDeferred = null
            }, 250)
          }
          dispatch(loggingIn(false))
          dispatch(loginError(true))
          reject(err.response.body)
        })
    })
    return deferred
  }
}

export const register = data => {
  return dispatch => {
    dispatch(registering())
    const deferred = new Promise((resolve, reject) => {
      AUTH.post(`/users`)
        .set("Content-Type", "application/json")
        .send({
          ...data,
          public: 1,
        })
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }

          return response
        })
        .then(response => response.body)
        .then(data => {
          if (data.message === "User created") {
            API.set("Authorization", data.token)
            AUTH.set("Authorization", data.token)
            dispatch(getUser(data.id, true))
              .then(getUserResponse => {
                dispatch(registering(false))
                dispatch(registerSuccess(getUserResponse, data.token))
                dispatch(
                  openSnackBar({
                    message: "Registration Successful",
                  })
                )
                if (loginDialogDeferred) {
                  loginDialogDeferred.resolve()
                  setTimeout(() => {
                    loginDialogDeferred = null
                  }, 250)
                }
                resolve(getUserResponse)
              })
              .catch(reject)
          } else if (data.message === "User creation error") {
            let err
            if (
              data.error.hasOwnProperty("sqlMessage") &&
              data.error.sqlMessage.indexOf("Duplicate entry") > -1
            ) {
              // bad password
              err = "That phone number already exists"
            } else {
              // bad pin
              err = "There was an error registering"
            }
            dispatch(
              openSnackBar({
                message: err,
              })
            )
            dispatch(registering(false))
            dispatch(registerError(true))
            reject(err)
          }
        })
        .catch(err => {
          if (loginDialogDeferred) {
            loginDialogDeferred.reject(err.response.body)
            setTimeout(() => {
              loginDialogDeferred = null
            }, 250)
          }
          dispatch(registering(false))
          dispatch(registerError(true))
          reject(err.response.body)
        })
    })
    return deferred
  }
}

export const refreshToken = currentToken => {
  // const s = store.getState()
  // console.log("s", s)
  // debugger
  // if (currentToken === undefined || currentToken === null) {
  //   this.props.history.push(`/login`)
  // }
  return dispatch => {
    return AUTH.get(`/auth`)
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText)
        }

        return response
      })
      .then(response => response.body)
      .then(data => {
        dispatch(loginSuccess(undefined, data.token))
        API.set("Authorization", data.token)
        AUTH.set("Authorization", data.token)
        return data
      })
      .catch(data => dispatch(loginError(true)))
  }
}

export const sendMagicLink = userId => {
  return dispatch => {
    return AUTH.get(`/users/${userId}/link`)
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText)
        }

        dispatch(loggingIn(false))

        return response
      })
      .then(response => response.body)
  }
}

export const sendPin = phone => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      AUTH.post(`/users/pin`)
        .send({
          phone,
        })
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }
          // This is the spot that the debugger is at when it sends the PIN
          dispatch(loggingIn(false))

          return response
        })
        .then(response => response.body)
        .then(response => {
          if (response.message === "New pin generated") {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(err => {
          reject(err.response.body)
        })
    })
    return deferred
  }
}

export const magicLink = magicLink => {
  return dispatch => {
    dispatch(loggingIn())
    const deferred = new Promise((resolve, reject) => {
      AUTH.post(`/auth/link`)
        .set("Content-Type", "application/json")
        .send({ magic_link: magicLink })
        .then(response => {
          if (!response.ok) {
            throw Error(response.statusText)
          }

          return response
        })
        .then(response => response.body)
        .then(data => {
          if (data.message === "Auth success") {
            API.set("Authorization", data.token)
            AUTH.set("Authorization", data.token)
            dispatch(getUser(data.id, true))
              .then(getUserResponse => {
                dispatch(loggingIn(false))
                dispatch(loginSuccess(getUserResponse, data.token))
                dispatch(
                  openSnackBar({
                    message: "Login Successful",
                  })
                )
                if (loginDialogDeferred) {
                  loginDialogDeferred.resolve()
                  setTimeout(() => {
                    loginDialogDeferred = null
                  }, 250)
                }
                resolve(getUserResponse)
              })
              .catch(reject)
          } else if (data.message === "Auth failed") {
            // Sometimes getting in here trying to send sms pin
            let err
            if (data.type === "pass") {
              // bad password
              err = "The password was wrong"
            } else {
              // bad pin
              err = "The pin number was wrong"
            }
            dispatch(
              openSnackBar({
                message: err,
              })
            )
            dispatch(loggingIn(false))
            dispatch(loginError(true))
            reject(err)
          }
        })
        .catch(data => {
          if (loginDialogDeferred) {
            loginDialogDeferred.reject()
            setTimeout(() => {
              loginDialogDeferred = null
            }, 250)
          }
          if (data.status === 404) {
            dispatch(
              openSnackBar({
                message: "Account not found",
              })
            )
          } else {
            dispatch(
              openSnackBar({
                message: "There was an error logging in",
              })
            )
          }
          dispatch(loggingIn(false))
          dispatch(loginError(true))
          reject(data)
        })
    })
    return deferred
  }
}

export const hiddenLoginModal = () => {
  return new Promise((resolve, reject) => {
    const s = store.getState()
    if (s.authentication.authenticatedUser.id) {
      return resolve({
        status: "logged in",
        user: s.authentication.authenticatedUser,
      })
    } else {
      store.dispatch({
        type: "HIDDEN_LOGIN_MODAL",
        payload: {
          open: true,
          promise: {
            resolve: data => {
              store.dispatch({
                type: "HIDDEN_LOGIN_MODAL",
                payload: { open: false, promise: {} },
              })
              resolve(data)
            },
            reject: data => {
              store.dispatch({
                type: "HIDDEN_LOGIN_MODAL",
                payload: { open: false, promise: {} },
              })
              reject(data)
            },
          },
        },
      })
    }
  })
}
